export default __webpack_public_path__ + "static/media/hero-verified.4fb9741a.svg";